export default __webpack_public_path__ + "static/media/subjects-blue.e7944a79.svg";